<template>
  <div class="pt-2 pb-5 px-15">
    <v-card class="pa-2">
      <v-card-title class="py-1">{{ trans('objectGroup.settlementPdf.page', {pageNumber: 1}) }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="text--primary">
        {{ trans('objectGroup.settlementPdf.coverSheet') }}
      </v-card-text>
    </v-card>

    <v-card v-for="(page, pageIndex) in pages" :key="pageIndex" class="mt-5 pa-2">
      <v-card-title class="py-1">
        {{ trans('objectGroup.settlementPdf.page', {pageNumber: 2 + pageIndex}) }}
        <delete-icon-button @click="removePage(pageIndex)"></delete-icon-button>
      </v-card-title>
      <v-divider class="my-1"></v-divider>
      <v-simple-table class="very-simple" dense>
        <tbody>
          <tr v-for="(pageContent, pageContentIndex) in page" :key="pageContentIndex">
            <td style="width: 0">
              <delete-icon-button @click="removePageContent(pageIndex, pageContentIndex)"></delete-icon-button>
            </td>
            <template v-if="pageContent.content">
              <td style="width: 40%" class="pb-3">
                <v-select v-model="pageContent.content" :items="pageContentTypes" hide-details="true" />
              </td>
              <td style="width: 60%">
                <v-text-field v-model="pageContent.desc" hide-details="true">
                  <span slot="prepend" class="pt-1 font-weight-medium">{{ trans('objectGroup.settlementPdf.headline') }}:</span>
                </v-text-field>
              </td>
            </template>
            <td v-else style="width: 100%" colspan="2">
              <v-textarea
                  class="mt-3"
                  rows="2"
                  hide-details="true"
                  dense
                  outlined
                  v-model="pageContent.text"
              />
            </td>
          </tr>
          <tr>
            <td colspan="99" class="py-3 px-0" style="height: 0">
              <v-divider></v-divider>
            </td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2" class="pb-1">
              <v-btn small @click="addPageContent(pageIndex, pageContentTypes[0].value)">
                <v-icon left>mdi-table-large-plus</v-icon> {{ trans('objectGroup.settlementPdf.addContent') }}
              </v-btn>
              <v-btn class="ml-3" small @click="addPageContent(pageIndex, null)">
                <v-icon left>mdi-message-plus-outline</v-icon> {{ trans('objectGroup.settlementPdf.addText') }}
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>

    <v-btn class="mt-5" small @click="addPage">
      <v-icon left>mdi-text-box-plus</v-icon> {{ trans('objectGroup.settlementPdf.addPage') }}
    </v-btn>

  </div>
</template>

<script>

import DeleteIconButton from '@/components/DeleteIconButton';
import {LocaleUtils} from '@/utils/locale-utils';

const pageContentTypes = [
  {value: 'PAYMENT_SUMMARY', text: 'Zahlungsströme'},
  {value: 'PROVISIONS', text: 'Provisionsabrechnung'},
  {value: 'SETTLEMENT', text: 'Endabrechnung'},
  {value: 'EXTRA_PAYMENTS', text: 'Zusatzrechnungen'},
];

export default {
  name: 'SettlementPageSetup',
  mixins: [
      LocaleUtils
  ],
  components: {DeleteIconButton},
  data: () => ({
        pageContentTypes: pageContentTypes
    }
  ),
  props: {
    pages: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    addPage() {
      this.pages.push([]);
    },
    addPageContent(pageIndex, type) {
      this.pages[pageIndex].push({
        content: type,
        desc: '',
        text: ''
      });
    },
    removePage(pageIndex) {
      this.pages.splice(pageIndex, 1);
    },
    removePageContent(pageIndex, contentIndex) {
      this.pages[pageIndex].splice(contentIndex, 1);
    }
  }
}
</script>

<style scoped>
  .very-simple > div > table > tbody > tr:hover {
    background: initial !important;
  }
  .very-simple > div > table > tbody > tr > td {
    border-bottom: none !important;
  }
</style>